import { render, staticRenderFns } from "./BirdSaleManage.vue?vue&type=template&id=e071b4e6&scoped=true&"
import script from "./BirdSaleManage.vue?vue&type=script&lang=js&"
export * from "./BirdSaleManage.vue?vue&type=script&lang=js&"
import style0 from "./BirdSaleManage.vue?vue&type=style&index=0&id=e071b4e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e071b4e6",
  null
  
)

export default component.exports